var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"SegmentedProgressBar"},_vm._l((_vm.segments),function(segment,i){return _c('div',{key:i,staticClass:"Segment",class:{ done: segment.done },style:({ backgroundColor: _vm.styles[segment.style] })})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }